<template>
  <div id="app">
    <div style="display: none;">
      <img :src="shareImgSrc" alt="">
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
const jsonp = require("jsonp");
const sha1 = require("js-sha1");
export default {
  name: "App",
  components: {},
  data() {
    return {
      shareImgSrc:''
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.setShare();
  },
  methods: {
    setShare() {
      var that = this;
      const domain = "https://mmadmin.tmuyun.com";
      /* 测试：https://testmmadmin.tmuyun.com
          预发布：https://premmadmin.tmuyun.com
          正式：https://mmadmin.tmuyun.com */
      jsonp(
        `${domain}/api/callback/pub/getRadioShareInfo?id=${that.$route.query.id}`,
        {
          param: "callbak"
        },
        (error, res) => {
          if (res.code == 0) {
            const { AppId, tiket, noncestr, title, desc, image } = res.data;
            const timestamp = new Date().getTime();
            const signature = `jsapi_ticket=${tiket}&noncestr=${noncestr}&timestamp=${timestamp}&url=${
              window.location.href.split("#")[0]
            }`;
            wx.config({
              debug: false, // 开启调试模式,开发时可以开启
              appId: AppId,
              timestamp: timestamp,
              nonceStr: noncestr,
              signature: sha1(signature),
              jsApiList: [
                "onMenuShareAppMessage",
                "onMenuShareTimeline",
                "onMenuShareQQ",
                "onMenuShareWeibo",
                "onMenuShareQZone"
              ]
            });
            const shareObj = {
              title: title,
              desc: desc,
              link: window.location.href,
              imgUrl: image
            };
            that.shareImgSrc = image;
            this.wxShare(shareObj);
            this.QQShare(shareObj, res.data);
          }
        }
      );
    },
    QQShare(shareObj, wxdata) {
      const { title, imgurl, desc, link} = shareObj;
      var t = document.createElement("meta");
      t.content = `itemprop="name" content="${title}"`;
      var i = document.createElement("meta");
      i.content = `itemprop="image" content="${imgurl}"`;
      var d = document.createElement("meta");
      d.content = `itemprop="description" content="${desc}"`;
      d.name = "description";
      var parent = document.getElementsByTagName("head")[0];
      parent.insertBefore(i, parent.childNodes[0]);
      parent.insertBefore(d, parent.childNodes[0]);
      parent.insertBefore(t, parent.childNodes[0]);
      document.title = title;
      /* mqq.data.setShareInfo(
          {
            share_url: link,
            title: title,
            desc: desc,
            image_url: imgurl
          },
          function() {}
        ); */
      setShareInfo({
        title: title,
        summary: desc,
        pic: imgurl,
        url: link,
        /* WXconfig: {
          swapTitleInWX: false,
          appId: wxdata.AppId,
          timestamp: timestamp,
          nonceStr: wxdata.noncestr,
          signature: signature
        } */
      });
    },
    wxShare(shareObj) {
      const { title, imgUrl, desc, link } = shareObj;
      wx.ready(() => {
        wx.onMenuShareTimeline({
          title: title,
          desc: desc,
          link: link,
          imgUrl: imgUrl,
          success(res) {},
          cancel(res) {}
        });
        wx.onMenuShareAppMessage({
          title: title,
          desc: desc,
          link: link,
          imgUrl: imgUrl,
          success(res) {},
          cancel(res) {}
        });
        wx.onMenuShareQQ({
          title: title,
          desc: desc,
          link: link,
          imgUrl: imgUrl,
          success(res) {},
          cancel(res) {}
        });
        wx.onMenuShareWeibo({
          title: title,
          desc: desc,
          link: link,
          imgUrl: imgUrl,
          success(res) {},
          cancel(res) {}
        });
        wx.onMenuShareQZone({
          title: title,
          desc: desc,
          link: link,
          imgUrl: imgUrl,
          success(res) {},
          cancel(res) {}
        });
      });
    }
  }
};
</script>

<style lang="less">
#app {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue